import { useState } from "react"
import axios from "axios"
import trEn from "../i18n/react-intl/en.json"
import trEs from "../i18n/react-intl/es.json"
import trIt from "../i18n/react-intl/it.json"
import trFr from "../i18n/react-intl/fr.json"

function useTranslation() {
  let translation_ = {}
  let messages_ = {
    es: trEs,
    en: trEn,
    it: trIt,
    fr: trFr,
  }
  let locale = process.env.LOCALE === "undefined" ? "en" : process.env.LOCALE
  //Use custom translation if its available
  try {
    if (process.env.TRANSLATION === "") {
      translation_ = messages_[locale]
    } else {
      translation_ = JSON.parse(process.env.TRANSLATION)
    }
  } catch (error) {
    translation_ = messages_[locale]
  }

  const [translation, setTranslation] = useState(translation_)


  //Default locale is en
  const fetchTranslation = () => {
    const config = {
      headers: {
        "Content-Type": "application/json",

      },
      withCredentials: true,
    }
    axios
      .get(
        `/a/courses/__translations__/${locale}.json`,
        config,
      )
      .then(function (response) {
        if (response.data) {
          setTranslation((current_translation) => {
            return {
              ...current_translation,
              ...response.data
            }
          })

        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  return { locale, translation, fetchTranslation }
}
export default useTranslation
